import { Link, useParams, useSearchParams } from "react-router-dom";
import Footer from "../../../../Components/Footer";
import Header from "../../../../Components/Header";
import PriceBar from "../../../../Components/PriceBar";
import "../index.css";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getPlanDetails } from "../../../../Features/EarnCampaign/earnSlice";
import moment from "moment";

function EarnPlanDetails() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const earnCurrency = searchParams.get("currency");
  const { planDetails, isLoading } = useSelector((state) => state?.earn);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPlanDetails({ planid: id }));
  }, [id]);

  return (
    <div className="earn-history">
      <Header />
      <PriceBar />
      <div className="container">
        <div className="row pt-5 pb-3 align-items-center">
          <div className="col-12 col-sm-6 pb-2 pb-md-0">
            <h1 className="txtColor text-center text-sm-start text-semibold">
              Earn Plan Details
            </h1>
          </div>
          <div className="col-12 col-sm-6 d-flex justify-content-center justify-content-sm-end align-items-center gap-2">
            <Link to="/earn-history">View Earn History</Link>
          </div>
        </div>

        {isLoading ? (
          <div className="container mb-5">
            <span className="txtColor">Loading</span>
          </div>
        ) : (
          <>
            <div className="table-responsive mb-5">
              <table className="table">
                <thead>
                  <tr>
                    <th className="head" style={{ width: "25%" }}>
                      Earn Date
                    </th>
                    <th className="head" style={{ width: "25%" }}>
                      Bonus Tier
                    </th>
                    <th className="head" style={{ width: "25%" }}>
                      Earned
                    </th>
                    <th className="head" style={{ width: "25%" }}>
                      Bonus
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {planDetails?.data?.length > 0 ? (
                    planDetails?.data?.map((d) => (
                      <tr>
                        <td sstyle={{ width: "25%" }}>
                          {moment(d?.EarnDate).format("DD-MM-YYYY")}
                        </td>
                        <td style={{ width: "25%" }}>{d?.BonusTier}</td>
                        <td style={{ width: "25%" }}>
                          {d?.EarnedPrincipal} {earnCurrency}
                        </td>
                        <td style={{ width: "25%" }}>
                          {d?.EarnedBonus} {earnCurrency}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <div className="py-5 text-center">No Data</div>
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>

      <Footer />
    </div>
  );
}

export default EarnPlanDetails;
